module.exports = __webpack_public_path__ + "static/themes-matchingaccents-dont-0de7357a3f68ccca0ba74da22123451e.png";